<div>
  <span class="mr-[12px]">
    {{ 'automation-msg_rules_html_w_between' | translate }}
    <!-- Between -->
  </span>

  <nz-select
    nzSize="large"
    class="min-w-[100px]"
    [(ngModel)]="value.start"
    (ngModelChange)="onSelectNightStart($event)"
    [nzOptions]="listOfNightsLeftOption"
    [nzDropdownMatchSelectWidth]="false"
  ></nz-select>
  <span class="mx-[12px]">
    {{ 'automation-msg_rules_html_w_and' | translate }}
    <!-- and -->
  </span>

  <nz-select
    nzSize="large"
    class="min-w-[100px]"
    [(ngModel)]="value.end"
    (ngModelChange)="onSelectNightEnd($event)"
    [nzOptions]="listOfNightsRightOption"
    [nzDropdownMatchSelectWidth]="false"
  ></nz-select>
</div>
